export interface EmptyStateProps {
  message: string;
}

export function EmptyState({ message }: EmptyStateProps) {
  return (
    <div className="flex flex-1 animate-fade-in items-center justify-center rounded border border-dashed">
      <p className="text-center text-sm">{message}</p>
    </div>
  );
}
